import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSidenavModule, MatToolbarModule } from '@angular/material';

import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { routing } from './app-routing.module';

import { AppComponent } from './app.component';

import { UserIdleModule } from 'angular-user-idle';


import { StoreModule } from '@ngrx/store';
import { reducer } from './statemanagement/reducer/parameter.reducer';
import { DecimalPipe } from '@angular/common';

/**
 * `App Module is the main entry point into Angular's bootstraping process
 */

@NgModule({
  declarations: [
        AppComponent
  ],
  imports: [
      HttpClientModule,
      HttpModule,
      FormsModule,
      BrowserModule,
      BrowserAnimationsModule,
      MatSidenavModule,
      MatToolbarModule,
      CoreModule.forRoot(),
      SharedModule,
      routing,
      UserIdleModule.forRoot({idle: 60, timeout: 15, ping:60}),

      StoreModule.forRoot(
          {
            parameter: reducer  
          })
    ],
    providers: [DecimalPipe],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/app.module.ts